// Утилита для управления логами Telegram Web App

// Сохраняем оригинальные методы console
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug
};

// Функция для отключения логов Telegram Web App
export const disableTelegramLogs = () => {
  // Переопределяем console.log для фильтрации логов Telegram
  console.log = (...args: any[]) => {
    const message = args.join(' ');
    
    // Фильтруем только логи Telegram Web App
    if (
      message.includes('[Telegram.WebView]') ||
      message.includes('telegram-web-app.js:') ||
      (message.includes('postEvent') && message.includes('web_app_')) ||
      (message.includes('receiveEvent') && message.includes('web_app_'))
    ) {
      return; // Не выводим логи Telegram
    }
    
    // Выводим остальные логи
    originalConsole.log(...args);
  };

  // Переопределяем console.warn для фильтрации предупреждений Telegram
  console.warn = (...args: any[]) => {
    const message = args.join(' ');
    
    if (
      message.includes('[Telegram.WebView]') ||
      message.includes('telegram-web-app.js:')
    ) {
      return;
    }
    
    originalConsole.warn(...args);
  };

  // Переопределяем console.error для фильтрации ошибок Telegram
  console.error = (...args: any[]) => {
    const message = args.join(' ');
    
    if (
      message.includes('[Telegram.WebView]') ||
      message.includes('telegram-web-app.js:')
    ) {
      return;
    }
    
    originalConsole.error(...args);
  };
};

// Функция для включения всех логов обратно
export const enableAllLogs = () => {
  console.log = originalConsole.log;
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
  console.info = originalConsole.info;
  console.debug = originalConsole.debug;
};

// Функция для отключения только логов Telegram (остальные логи остаются)
export const enableTelegramLogs = () => {
  console.log = originalConsole.log;
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
  console.info = originalConsole.info;
  console.debug = originalConsole.debug;
};

// Функция для проверки, включены ли логи Telegram
export const isTelegramLogsEnabled = () => {
  return console.log === originalConsole.log;
};
